import {
  EventBus,
  USER_SETTINGS_REFRESHED,
} from "Public/store/modules/eventbus";
import {
  updateAvatarSettings,
  updateExplorerSettings,
} from "Adapters/ApiAdapter/userSettings";
import { ExplorerType } from "Consts/explorer";

export const SETTINGS_SET = "settings/set";
export const SETTINGS_GET = "settings/get";
export const SETTINGS_EXPLORER_GET = "settings/explorer/get";
export const SETTINGS_EXPLORER_DATA_GET = "settings/explorer/data/get";
export const SETTINGS_EXPLORER_TOGGLE = "settings/explorer/toggle";

export const SETTINGS_AVATAR_CONFIG_GET = "settings/avatar/config/get";
export const SETTINGS_AVATAR_CONFIG_SET = "settings/avatar/config/set";
export const SETTINGS_AVATAR_CONFIG_UPDATE = "settings/avatar/config/update";

export const SETTINGS_EXPLORER_STATUS_SET = "settings/explorer/status/set";
export const SETTINGS_EXPLORER_COLUMNS_SET = "settings/explorer/columns/set";
export const SETTINGS_EXPLORER_SET = "settings/explorer/set";

const defaultExplorerValue = { status: 1, columns: [] };

const state = {
  settings: {
    explorer_view: {
      [ExplorerType.module]: null,
      [ExplorerType.social]: null,
    },
    avatar: {},
  },
};

const getters = {
  [SETTINGS_GET]: ({ settings }) => {
    return settings;
  },
  [SETTINGS_EXPLORER_GET]: ({ settings }, key) => {
    const explorer = settings.explorer_view[key];
    if (!explorer) return { ...defaultExplorerValue };
    return settings.explorer_view[key];
  },
  [SETTINGS_EXPLORER_DATA_GET]:
    ({ settings }) =>
    (explorer, key) => {
      const explorerView = settings.explorer_view[explorer];
      if (!explorerView) return defaultExplorerValue[key];
      else return explorerView[key];
    },
  [SETTINGS_AVATAR_CONFIG_GET]: ({ settings }) => {
    return settings.avatar;
  },
};

const actions = {
  [SETTINGS_EXPLORER_TOGGLE]: ({ commit, state }, payload) => {
    const [key, value] = Object.entries(payload)[0];
    const updatedExplorerView = {
      ...state.settings.explorer_view[key],
      status: value,
    };
    const updatedExplorer = {
      ...state.settings.explorer_view,
      [key]: updatedExplorerView,
    };
    return updateExplorerSettings(JSON.stringify(updatedExplorer)).then(() => {
      commit(SETTINGS_EXPLORER_SET, updatedExplorer);
      EventBus.$emit(USER_SETTINGS_REFRESHED);
    });
  },
  [SETTINGS_AVATAR_CONFIG_UPDATE]: async ({ commit }, payload) => {
    await updateAvatarSettings(JSON.stringify(payload));
    commit(SETTINGS_AVATAR_CONFIG_SET, payload);
  },
};

const mutations = {
  [SETTINGS_SET]: (state, settings) => {
    state.settings = settings;
  },
  [SETTINGS_EXPLORER_SET]: (state, updatedExplorer) => {
    state.settings.explorer_view = { ...updatedExplorer };
  },
  [SETTINGS_EXPLORER_STATUS_SET]: ({ settings }, key, value) => {
    const explorer = settings.explorer_view[key];
    if (!explorer)
      settings.explorer_view[key] = { ...defaultExplorerValue, status: value };
    else settings.explorer_view[key] = { ...explorer, status: value };
  },
  [SETTINGS_EXPLORER_COLUMNS_SET]: ({ settings }, key, value) => {
    const explorer = settings.explorer_view[key];
    if (!explorer)
      settings.explorer_view[key] = {
        ...defaultExplorerValue,
        columns: [...value],
      };
    else settings.explorer_view[key] = { ...explorer, columns: [...value] };
  },
  [SETTINGS_AVATAR_CONFIG_SET]: (state, updatedAvatar) => {
    state.settings.avatar = { ...updatedAvatar };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
